export default {
  "menu": {
    "undefined": "__UNDEFINED_MENU_ITEM__",
    "Search": "Recherche",
    "Insights": "Assistant IA",
    "Catalog": "Lac de données",
    "Hub": "Jeux de données",
    "Flows": "Flows",
    "Members": "Membres",
    "Connections": "Connections",
    "Monitor": "Monitor",
    "Dashboard": "Tableaux de bord",
    "Settings": "Settings",
    "WhatsNew": "Nouveautés",
    "home": "home",
    "Home": "Vue d'ensemble",
    "section": {
      "Workspace": "Espace de travail"
    },
    "group": {
      "DataAndModels": "Données et modèles"
    },
    "role": {
      "ADMIN": "Administrateur de l'organisation",
      "EDITOR": "Éditeur",
      "VIEWER": "Lecteur"
    },
    "sidebar": {
      "label": "Principal",
      "collapse": "Réduire la barre latérale",
      "expand": "Agrandir la barre latérale",
      "createWorkspace": "Créer un espace de travail",
      "createWorkspaceUsage": "Créer un espace de travail ({used} sur {limit})",
      "workspaceLimitReached": "Limite d'espaces de travail atteinte ({used} sur {limit}). Contactez BEEM pour en ajouter.",
      "account": "{name} · Compte"
    },
    "orgSwitcher": {
      "organization": "Organisation",
      "open": "Changer d’organisation…",
      "title": "Changer d’organisation",
      "searchLabel": "Rechercher une organisation par nom ou acronyme",
      "placeholder": "Nom ou acronyme, p. ex. PET",
      "count": "{count} organisations · par acronyme",
      "countFiltered": "{shown} sur {count}",
      "showNames": "Afficher les noms",
      "hideNames": "Masquer les noms",
      "current": "Actuelle",
      "currentLabel": "{acronym}, organisation actuelle",
      "empty": "Aucune organisation ne correspond à « {query} »."
    },
    "account": {
      "settings": "Profile & Account",
      "account": "Compte",
      "logout": "Se déconnecter",
      "helpAndSupport": "Aide & Support",
      "giveFeedback": "Donner un avis"
    },
    "Usage": "Usage",
    "dpuUsage": "{dpuAmount} DPUs",
    "dpuLimit": "on {limit}",
    "dpuReset": "Resets in {daysLeft} days",
    "dpuError": "Unable to calculate usage.",
    "dpuSupport": "Please contact our support team"
  }
};
